<template>
  <Container>
    <div class="flex flex-col sm:flex-row">
      <slot />
    </div>
  </Container>
</template>
